module.exports = __webpack_public_path__ + "static/media/ng.3d24b912.webp";